"use strict";
var getAssetContent = require("./getAssetContent");

/**
 * @function
 * @description Function to set the session variables
 * @param {string} sessionVariable - session variable
 */
const setPopupSessionVariables = (sessionVariable) => {
    let variable = sessionStorage.getItem(sessionVariable);

    if (!variable) {
        sessionStorage.setItem(sessionVariable, false);
    }
};

/**
 * @function
 * @description Fnction to init the goodbye message popup
 */
const initGoodbyeMessage = () => {
    const $body = $("body");
    const $footerContent = $("#footercontent");
    const popupTrigger = $footerContent.data("modal-trigger");
    const popupPeriod = $footerContent.data("modal-period");
    const seconds = popupPeriod * 1000;

    if (popupTrigger === 0 || popupTrigger === 1) {
        let modalGroupVariables = "group1PopupShown, group2PopupShown, group3PopupShown";

        $.each(modalGroupVariables.split(", "), function (index, item) {
            setPopupSessionVariables(item);
        });

        if (!window.mqRespond.status.lgDown) {
            const $goodbyeMessage = $(".js-goodbye-message");

            if ($goodbyeMessage.length) {
                const popupGroup = $goodbyeMessage.data("modal-group");

                if (popupGroup) {
                    const allocatedPopupVariable = sessionStorage.getItem(popupGroup + "PopupShown");

                    if ($goodbyeMessage.length && allocatedPopupVariable !== "true") {
                        if (popupTrigger === 0) {
                            $body.one("mouseleave", () => {
                                if (!$body.hasClass("modal-open")) {
                                    getAssetContent($goodbyeMessage);
                                }
                            });
                        } else {
                            setTimeout(() => {
                                if (!$body.hasClass("modal-open")) {
                                    getAssetContent($goodbyeMessage);
                                }
                            }, seconds);
                        }
                    }
                }
            }
        }
    }
};

module.exports = initGoodbyeMessage;
